import { Environment } from './models/Environment';

export const environment: Environment = {
    production: false,
    baseUrl: '',
    authTestEnabled: false,
    authTestUser: null
};
